import { get } from "lodash";
import { DATABAR_SCHEMA } from "../../../utils/schemas/language/components/databarSchema";
import { getLanguageContent } from "../../../utils/language/languageSelector";

const DataBar = ({ langKey }) => {
  const content = getLanguageContent(DATABAR_SCHEMA, langKey);
  return (
    <section id="bar">
      <div className="content">
        <div id="dataBar">
          <div className="bar-item">
            <h5>{content.card_1.title}</h5>
            <p>{content.card_1.description}</p>
          </div>
          <hr />
          <div className="bar-item">
            <h5>{content.card_2.title}</h5>
            <p>{content.card_2.description}</p>
          </div>
          <hr />
          <div className="bar-item">
            <h5>{content.card_3.title}</h5>
            <p>{content.card_3.description}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DataBar;
